import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';

import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Form } from 'antd';
import PlaylistItem from './PlaylistItem';
import { Text } from 'basic-ui-lib';
import { FormValues } from '../PlaylistForm';
import { IContentItem } from 'modules/playlist/interfaces/api';

const DragDropPlaylist = () => {
  const sensors = useSensors(useSensor(PointerSensor));
  const form = Form.useFormInstance<FormValues>();
  const contentItems = Form.useWatch('contentItems', form) ?? [];

  const reindexContentItems = () => {
    const items = form.getFieldValue('contentItems') ?? [];
    const updated = items.map((item: IContentItem, i: number) => ({
      ...item,
      indexPlay: i,
    }));
    form.setFieldValue('contentItems', updated);
  };

  const createOnDragEnd =
    (fields: any[], move: (from: number, to: number) => void) =>
    ({ active, over }: any) => {
      if (!over || active.id === over.id) return;

      const oldIndex = fields.findIndex((f) => f.key === active.id);
      const newIndex = fields.findIndex((f) => f.key === over.id);

      if (oldIndex !== -1 && newIndex !== -1) {
        move(oldIndex, newIndex);
        setTimeout(reindexContentItems, 0);
      }
    };
  return (
    <Form.List name='contentItems'>
      {(fields, { move, remove }) => (
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={createOnDragEnd(fields, move)}>
          <SortableContext items={fields.map((f) => f.key)} strategy={verticalListSortingStrategy}>
            {fields.length ? (
              fields.map((field, index) => (
                <PlaylistItem 
                  key={field.key} 
                  id={field.key} 
                  item={contentItems[index]} 
                  ids={index} 
                  onRemove={() => {
                    remove(field.name);
                    setTimeout(reindexContentItems, 0);
                  }}
                />
              ))
            ) : (
              <Text>No media added to the playlist yet.</Text>
            )}
          </SortableContext>
        </DndContext>
      )}
    </Form.List>
  );
};

export default DragDropPlaylist;
